import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";
import { showToast } from "./ToastSlice";

export const profileEvents = createAsyncThunk(
  "events/fetchEvents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post("/getProfileEvent");

      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message);
    }
  }
);

/**
 * Add or update a meeting
 */
export const addOrUpdateMeeting = createAsyncThunk(
  "events/addOrUpdateMeeting",
  async (meetingData, { dispatch, rejectWithValue }) => {
    try {
      const response = await api.post("/meeting/addUpdateMeeting", meetingData);

      dispatch(
        showToast({
          message: response.data.message,
          variant: "success",
        })
      );

      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to save meeting";

      dispatch(
        showToast({
          message: errorMessage,
          variant: "danger",
        })
      );

      return rejectWithValue(errorMessage);
    }
  }
);

/**
 * Delete a meeting
 */
export const deleteMeeting = createAsyncThunk(
  "events/deleteMeeting",
  async (
    { contact_id, meeting_id, category },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = await api.delete("/meeting/deleteMeeting", {
        data: { contact_id, meeting_id, category },
      });

      dispatch(
        showToast({
          message: response.data.message,
          variant: "success",
        })
      );

      return { meeting_id };
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete meeting";

      dispatch(
        showToast({
          message: errorMessage,
          variant: "danger",
        })
      );

      return rejectWithValue(errorMessage);
    }
  }
);

export const eventSlice = createSlice({
  name: "events",
  initialState: {
    data: [],
    loading: false,
    operationInProgress: false,
  },
  reducers: {
    mergeGoogleEvents: (state, action) => {
      const nonGoogleEvents = state.data.filter((event) => !event.googleEvent);
      state.data = [...nonGoogleEvents, ...action.payload];
    },
    clearGoogleEvents: (state) => {
      state.data = state.data.filter((event) => !event.googleEvent);
    },
    // Clear entire events cache
    clearEventsCache: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(profileEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(profileEvents.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(profileEvents.rejected, (state) => {
        state.loading = false;
      })
      // Add/Update Meeting
      .addCase(addOrUpdateMeeting.pending, (state) => {
        state.operationInProgress = true;
      })
      .addCase(addOrUpdateMeeting.fulfilled, (state) => {
        state.operationInProgress = false;
      })
      .addCase(addOrUpdateMeeting.rejected, (state) => {
        state.operationInProgress = false;
      })
      // Delete Meeting
      .addCase(deleteMeeting.pending, (state) => {
        state.operationInProgress = true;
      })
      .addCase(deleteMeeting.fulfilled, (state) => {
        state.operationInProgress = false;
      })
      .addCase(deleteMeeting.rejected, (state) => {
        state.operationInProgress = false;
      });
  },
});
export const { mergeGoogleEvents, clearGoogleEvents, clearEventsCache } =
  eventSlice.actions;
export default eventSlice.reducer;
